/**
 * Функция для вычисления значения, отображаемого в IndicatorCounter.
 *
 * Спека: https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=3294-58066
 */
export const calcQuantity = (quantity: number, maxQuantity: number): string => {
    if (quantity >= maxQuantity && maxQuantity > 1) {
        return `${maxQuantity - 1}+`;
    }
    if (quantity < 0) {
        return "0";
    }

    return quantity.toString();
};
